export default __webpack_public_path__ + "locales/sw.ky.json";